import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { hasValue } from '../../../utils/helpers/value'
import { replaceOrAdd } from '../../../utils/helpers/lists'
import Button from '../../../packages/kiti/components/actions/Button'
import Modal from '../../../components/structure/Modal'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import ToRight from '../../../packages/kiti/components/helpers/ToRight'
import { useImperativeComponents } from '../form/replies/context/ImperativeComponentsContext'
import { useAlertModal } from '../../../utils/routes/modals/modalsActions'
import RepliesList from '../form/replies/RepliesList'
import { useFormatBlockReplies } from '../form/_form/formatRepliesFormData'
import { indexOfFirstInvalidReply } from '../../../modules/serviceOrders/executionV2/_helpers/saveServiceOrder'

const BlockModal = ({ value, selectedIndex, onChange, blockQuestions, onClose }) => {
  const initialState = React.useMemo(() => value[selectedIndex] || [], [value])
  const isEditing = hasValue(initialState)
  const { getBlockReplies, setFocus } = useImperativeComponents()
  const [replies, _setReplies] = React.useState(initialState)
  const openAlert = useAlertModal()

  const formattedReplies = useFormatBlockReplies(blockQuestions, replies)
  const childrenReplies = formattedReplies.filter(reply => !reply.isParent)

  const handleChange = () => {
    const questionsValues = getBlockReplies(blockQuestions)
    const firstInvalidReplyIndex = indexOfFirstInvalidReply(questionsValues)
    const checkEmptyValues = questionsValues.every(questionValue => questionValue.value === undefined)

    if (checkEmptyValues) {
      onClose()
      return
    }

    if (firstInvalidReplyIndex) {
      setFocus(firstInvalidReplyIndex.questionId)

      return openAlert('Respostas obrigatórias faltando', 'Verifique as perguntas com as tags vermelhas.', {
        icon: 'BsInfoCircle'
      })
    }

    const blockValues = replaceOrAdd(value, questionsValues, selectedIndex)
    onChange(blockValues)
    onClose()
  }

  return (
    <>
      <Title size="h5">{isEditing ? 'Editando' : 'Novo item'}</Title>
      <Separator weight={2} />
      <RepliesList replies={childrenReplies} allReplies={formattedReplies} />
      <Separator weight={4} />
      <ToRight>
        <Button disabled={false} onClick={() => handleChange()}>
          Salvar
        </Button>
      </ToRight>
    </>
  )
}

const Wrapper = props => (
  <Modal open={props.selectedIndex !== false} onClose={props.onClose} width="48rem">
    <BlockModal {...props} />
  </Modal>
)

export default Wrapper
